import { render, staticRenderFns } from "./NovelDetail.vue?vue&type=template&id=546406ff&scoped=true"
import script from "./NovelDetail.vue?vue&type=script&lang=ts"
export * from "./NovelDetail.vue?vue&type=script&lang=ts"
import style0 from "./NovelDetail.vue?vue&type=style&index=0&id=546406ff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546406ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546406ff')) {
      api.createRecord('546406ff', component.options)
    } else {
      api.reload('546406ff', component.options)
    }
    module.hot.accept("./NovelDetail.vue?vue&type=template&id=546406ff&scoped=true", function () {
      api.rerender('546406ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/NovelDetail.vue"
export default component.exports